import { Package, Clock, PoundSterling, TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";

interface StatsBarProps {
  totalOrders: number;
  unfulfilledOrders: number;
  revenueLast7Days: number;
  revenueToday: number;
}

export function StatsBar({
  totalOrders,
  unfulfilledOrders,
  revenueLast7Days,
  revenueToday,
}: StatsBarProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    }).format(amount);
  };

  const stats = [
    {
      label: "Total Orders",
      value: totalOrders.toString(),
      icon: Package,
      color: "text-emerald-400",
    },
    {
      label: "Unfulfilled",
      value: unfulfilledOrders.toString(),
      icon: Clock,
      color: unfulfilledOrders > 0 ? "text-amber-400" : "text-emerald-400",
    },
    {
      label: "Revenue (7 days)",
      value: formatCurrency(revenueLast7Days),
      icon: TrendingUp,
      color: "text-emerald-400",
    },
    {
      label: "Revenue (Today)",
      value: formatCurrency(revenueToday),
      icon: PoundSterling,
      color: "text-emerald-400",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((stat) => (
        <Card
          key={stat.label}
          className="bg-slate-900/70 backdrop-blur-md border-slate-700/60 p-4 md:p-6"
        >
          <div className="flex items-center gap-3">
            <stat.icon className={`w-6 h-6 md:w-8 md:h-8 ${stat.color}`} />
            <div>
              <p className="text-slate-400 text-xs md:text-sm">{stat.label}</p>
              <p className="text-lg md:text-2xl font-bold text-slate-100">
                {stat.value}
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
